import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "autoPreview", "clearButton"]

  open() {
    const modalElement = document.getElementById("featured-card-picker-modal")
    if (!modalElement || !window.bootstrap) return

    window.bootstrap.Modal.getOrCreateInstance(modalElement).show()
  }

  pick(event) {
    const button = event.currentTarget
    const cardUuid = button.dataset.cardUuid
    const source = button.querySelector(".featured-card-picker-preview-source")
    const input = document.getElementById("deck_input_main_card_override_uuid")

    if (!cardUuid || !input || !source) return

    input.value = cardUuid
    this.previewTarget.innerHTML = source.innerHTML
    this.showClearButton()
    this.hideModal()
  }

  clear() {
    const input = document.getElementById("deck_input_main_card_override_uuid")
    if (input) input.value = ""

    if (this.hasAutoPreviewTarget) {
      this.previewTarget.innerHTML = this.autoPreviewTarget.innerHTML
    }

    this.hideClearButton()
  }

  hideModal() {
    const modalElement = document.getElementById("featured-card-picker-modal")
    if (!modalElement || !window.bootstrap) return

    window.bootstrap.Modal.getOrCreateInstance(modalElement).hide()
  }

  showClearButton() {
    if (this.hasClearButtonTarget) this.clearButtonTarget.style.display = ""
  }

  hideClearButton() {
    if (this.hasClearButtonTarget) this.clearButtonTarget.style.display = "none"
  }
}
